export default "__VITE_ASSET__BOZ0uPV2__"